'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _find = require('lodash-compat/collection/find');

var _find2 = _interopRequireDefault(_find);

var _createChainedFunction = require('../utils/createChainedFunction');

var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);

var _ValidComponentChildren = require('../utils/ValidComponentChildren');

var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);

var _warning = require('warning');

var _warning2 = _interopRequireDefault(_warning);

var _Popover = require('../Popover');

var _Popover2 = _interopRequireDefault(_Popover);

var _OverlayTrigger = require('../OverlayTrigger');

var _OverlayTrigger2 = _interopRequireDefault(_OverlayTrigger);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MENUITEM_ROLE = _Popover2.default.defaultProps.bsRole;

var FeyeTimelineDate = function (_React$Component) {
  _inherits(FeyeTimelineDate, _React$Component);

  function FeyeTimelineDate(props) {
    _classCallCheck(this, FeyeTimelineDate);

    var _this = _possibleConstructorReturn(this, (FeyeTimelineDate.__proto__ || Object.getPrototypeOf(FeyeTimelineDate)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  _createClass(FeyeTimelineDate, [{
    key: 'onClick',
    value: function onClick() {
      if (this.props.active && this.props.onClick) {
        this.props.onClick(this.props.model);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          active = _props.active,
          topLabel = _props.topLabel,
          bottomLabel = _props.bottomLabel,
          totalCount = _props.totalCount,
          keyIndex = _props.keyIndex,
          onClick = _props.onClick,
          divisor = _props.divisor,
          className = _props.className,
          style = _props.style;

      var labelDisplay = (keyIndex - 1) % divisor === 0;

      var computedStyle = {
        left: (keyIndex - 1) / totalCount * 100 + '%'
      };
      if (style) {
        computedStyle = Object.assign({}, computedStyle, style);
      }
      var additionalClasses = className || '';
      var val = _react2.default.createElement(
        'span',
        { style: computedStyle, onClick: this.onClick, className: (0, _classnames2.default)(additionalClasses, "fe-timeline__date", { "fe-timeline__date--active": active }) },
        topLabel && labelDisplay && _react2.default.createElement(
          'span',
          { className: 'fe-timeline__date--top' },
          topLabel
        ),
        bottomLabel && labelDisplay && _react2.default.createElement(
          'span',
          { className: 'fe-timeline__date--bottom' },
          bottomLabel
        )
      );
      return children && active ? _react2.default.createElement(
        _OverlayTrigger2.default,
        { rootClose: true, trigger: 'click', placement: 'right', overlay: children },
        val
      ) : val;
    }
  }]);

  return FeyeTimelineDate;
}(_react2.default.Component);

FeyeTimelineDate.propTypes = {
  active: _propTypes2.default.boolean,
  bsRole: _propTypes2.default.string,
  topLabel: _propTypes2.default.string,
  bottomLabel: _propTypes2.default.string,
  totalCount: _propTypes2.default.number,
  divisor: _propTypes2.default.number,
  onClick: _propTypes2.default.function,
  model: _propTypes2.default.object
};

FeyeTimelineDate.defaultProps = {
  active: false,
  bsRole: 'timelineDate',
  totalCount: 1,
  model: {},
  divisor: 1
};

exports.default = FeyeTimelineDate;